/**
 * coreApi — thin wrapper around the core (non-plugin) REST endpoints.
 *
 * Provides:
 *   getHotel() / putHotel(patch)
 *   getSettings() / putSettings(patch)
 *
 * All responses are normalized so callers see plain objects. Any HTTP
 * error is thrown with a userMessage the UI can surface.
 */

const BASE = process.env.REACT_APP_BACKEND_URL;

async function request(path, options = {}) {
  const url = `${BASE}/api${path}`;
  let res;
  try {
    res = await fetch(url, {
      headers: { "Content-Type": "application/json" },
      ...options,
    });
  } catch (e) {
    const err = new Error(e.message || "Network error");
    err.userMessage = "Network error";
    throw err;
  }
  if (!res.ok) {
    let body = null;
    try {
      body = await res.json();
    } catch {
      /* response has no JSON body — leave body as null */
    }
    const err = new Error(`HTTP ${res.status}`);
    err.userMessage = body?.detail || `Request failed (${res.status})`;
    err.status = res.status;
    throw err;
  }
  return res.json();
}

export const coreApi = {
  getHotel: () => request("/hotel"),
  putHotel: (patch) =>
    request("/hotel", { method: "PUT", body: JSON.stringify(patch) }),

  getSettings: () => request("/settings"),
  putSettings: (patch) =>
    request("/settings", { method: "PUT", body: JSON.stringify(patch) }),
};
